import React from 'react';
// Constants
import { CompanyName, MainTitle, HOME_PAGE_URL } from '../../utils/Constants';
import NameHeaderComponent from '../general/NameHeaderComponent';
// Components

function IndexPageMainContainer() {
  return (
    <header className='grid w-full h-full text-colour1 dark:text-colour1'>
      <div className='grid text-center sm:justify-center items-center px-4'>
        {/* Name */}
        <section className='grid gap-4 h-fit'>
          <div>
            <h2 className='text-colour7 dark:text-colour7 font-titleFont text-xl lg:text-2xl font-semibold'>
              INTRODUCING
            </h2>
          </div>
          <NameHeaderComponent />
        </section>

        {/* Enter section */}
        <section className='grid gap-4 md:gap-6'>
          <section className='font-hello-paris-medium'>
            <div className=''>
              <h3 className='text-colour1 dark:text-colour1 text-xl lg:text-4xl font-semibold lg:leading-8'>
                {MainTitle}
              </h3>
            </div>
            <div>
              <h4 className='font-fancyFont text-xl lg:text-4xl'>
                You must be over 18
              </h4>
            </div>
          </section>

          {/* Cta */}
          <section>
            <div className='grid grid-cols-2 gap-2 px-2 mx-auto xs:px-6'>
              <a
                href='https://google.com'
                className='bg-colour1 hover:brightness-90 py-2 lg:py-3 lg:text-2xl font-titleFont text-colour2 rounded-md shadow-md shadow-colour1/10 sm:px-8'
              >
                Leave Now
              </a>
              <a
                href={HOME_PAGE_URL}
                className='bg-colour7 hover:brightness-90 py-2 lg:py-3 lg:text-2xl font-titleFont text-colour1 rounded-md shadow-md shadow-colour1/10 sm:px-8'
              >
                Meet Me
              </a>
            </div>
          </section>
        </section>

        {/* Copyright */}
        <section>
          <div>
            <p className=''>
              © {new Date().getFullYear()} {CompanyName}
            </p>
          </div>
        </section>
      </div>
    </header>
  );
}

export default IndexPageMainContainer;
